<template>
    <div v-if="isEditing" :class="componentClass">
        <input-group v-model="value">
            <template #input>
                <text-input
                    @keydown.enter="onFinishEditing"
                />
            </template>
        </input-group>

        <button-plain-icon
            :icon="IconFloppyDisk"
            is-custom-icon
            @click="onFinishEditing"
        />
    </div>

    <div v-else :class="componentClass">
        <text-decorator :size="FontSize.xs">
            <span>{{ props.modelValue }}</span>
        </text-decorator>

        <button-plain-icon
            :icon="IconPenLine"
            is-custom-icon
            @click="onStartEditing"
        />
    </div>
</template>

<script setup lang="ts">
    import { computed, ref } from 'vue';
    import IconPenLine from '@keyvue/one-awesome-icons/icons/regular/pen-line.svg?component';
    import IconFloppyDisk from '@keyvue/one-awesome-icons/icons/regular/floppy-disk.svg?component';
    import {
        ButtonPlainIcon,
        FontSize,
        InputGroup,
        TextDecorator,
        TextInput,
    } from '@keyvue/one-ui';

    const props = defineProps<{ modelValue: string }>();
    const emit = defineEmits<{
        (e: 'update:modelValue', value: string): void;
    }>();

    const value = ref(props.modelValue);
    const isEditing = ref(false);

    const componentClass = computed(() => {
        return {
            'inline-edit-text': true,
            'inline-edit-text--editing': isEditing.value,
        };
    });

    function onStartEditing() {
        isEditing.value = true;
    }

    function onFinishEditing() {
        isEditing.value = false;
        emit('update:modelValue', value.value);
    }
</script>

<style scoped lang="scss">
.inline-edit-text {
    display: flex;
    align-items: center;
    gap: size(md);

    &--editing {
        gap: size(sm);
    }
}
</style>
